<template>
    <div class="faq">
        <div class='logo'>
                <figure class='image'>
                <img src="../../assets/images/excel-logo-full.png">
            </figure>
        </div>
        <div class="faq-content">
            <h1 class="faq-title">
                Frequently Asked Questions (FAQ)
            </h1>
            <p class="answer">
                Below you will find series of frequently asked questions. Please refer to the video tutorial for answers.
            </p>
            <div class="faq-group">
                <p class="question">
                    How do I create an account to access Job Portal?
                </p>
                <p class="answer">
                    <iframe class="faq-video" src="https://player.vimeo.com/video/589950144" allow="fullscreen; picture-in-picture" allowfullscreen></iframe>
                </p>
            </div>
            <div class="faq-group">
                <p class="question">
                    How do I log into Job Portal?
                </p>
                <p class="answer">
                    <iframe class="faq-video" src="https://player.vimeo.com/video/589960515" allow="fullscreen; picture-in-picture" allowfullscreen></iframe>
                </p>
            </div>
            <div class="faq-group">
                <p class="question">
                    How do I submit scanned Verification of Service via Job Portal?
                </p>
                <p class="answer">
                    <iframe class="faq-video" src="https://player.vimeo.com/video/589964430" allow="fullscreen; picture-in-picture" allowfullscreen></iframe>
                </p>
            </div>
            <div class="faq-group">
                <p class="question">
                    How do I submit digital Verification of Service via Job Portal?
                </p>
                <p class="answer">
                    <iframe class="faq-video" src="https://player.vimeo.com/video/589968662" allow="fullscreen; picture-in-picture" allowfullscreen></iframe>
                </p>
            </div>
            <div class="faq-group">
                <p class="question">
                    How do I submit digital Verification of Service without creating a Job Portal account?
                </p>
                <p class="answer">
                    <iframe class="faq-video" src="https://player.vimeo.com/video/599049845" allow="fullscreen; picture-in-picture" allowfullscreen></iframe>
                </p>
            </div>
        </div>
    </div>
</template>
<script>


export default {
    data () {
        return {
        
        }
    }
};
</script>
<style>
html{
    overflow-y: hidden !important;
}
body{
    position: relative !important;
    overflow: auto !important;
    /* color: #000 !important; */
    background-color: #FFF !important;
}

.faq{
    max-width: 800px;
    position: relative;
    margin: 0 auto;
    padding: 10px;
    background-color: #FFF;
}

.logo{
    max-width: 500px;
    margin: 0 auto;
}

.faq-title{
    font-weight: bold;
    font-size: 30px;
}

.faq-content{
    margin-top: 50px;
}

.faq-group{
    margin-bottom: 50px;
}

.question{
    margin-top: 20px;
    font-weight: bold;
    font-size: 18px;
}

.answer{
    margin-top: 20px;
}

.faq-video{
    width: 100%;
    aspect-ratio: 16 / 9;
    border: 0;
}
</style>